import { render, staticRenderFns } from "./knowledge_page.vue?vue&type=template&id=187200fb&scoped=true"
import script from "./knowledge_page.vue?vue&type=script&lang=js"
export * from "./knowledge_page.vue?vue&type=script&lang=js"
import style0 from "./knowledge_page.vue?vue&type=style&index=0&id=187200fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187200fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187200fb')) {
      api.createRecord('187200fb', component.options)
    } else {
      api.reload('187200fb', component.options)
    }
    module.hot.accept("./knowledge_page.vue?vue&type=template&id=187200fb&scoped=true", function () {
      api.rerender('187200fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/knowledge_page.vue"
export default component.exports